import React from "react";
import { useParams, Link } from "react-router-dom";
import "../Flight/FlightDetails.css";
import { MdOutlineFlightTakeoff } from "react-icons/md";
import { MdOutlineFlightLand } from "react-icons/md";
import FlightDeal from "./Flightdeal";
import WhyChoose from "../WhyChoose/WhyChoose";
import Deal from "../Deal/Deal";
import { useNavigate } from "react-router-dom";
import Support from "../Support/Support";

const flights = [
  {
    id: "usa",
    city: "USA",
    economy: "£1840",
    premiumEconomy: "£3040",
    image: "/san.webp",
    description:
      "America, a huge and varied nation, provides all from energetic urban centers to amazing natural scenery. Discover famous places including New York, recognized for Times Square and Liberty Statue, or LA, location of Hollywood and bright beaches. America is also filled with heritage, featuring sights such as the White House in DC and the Grand Canyon in AZ. Whether you want thrills, culture, or rest, America presents options for all.",
    description2:
      "Every area in America possesses its individual special appeal. Enjoy the lively evening scene of Miami, the technology centers of Silicon Valley, or the picturesque splendor of the Rocky Mountains. The nation features a top-tier food culture, from deep-dish pizza in Chicago to smoked meats in Texas. Nature lovers can visit national reserves like Yellowstone and Yosemite, while city admirers can engage with the cultural centers of SF, Boston, and Las Vegas. Regardless of your preferences, America guarantees memorable moments.",
    destinations: [
      {
        id: "orlando",
        name: "Orlando",
        image: "/orlando.webp",
        price: "£284",
      },
      {
        id: "new-york",
        name: "New York",
        image: "/new-york.webp",
        price: "£260",
      },
      {
        id: "miami",
        name: "Miami",
        image: "/miami.avif",
        price: "£317",
      },
      {
        id: "las-vegas",
        name: "Las Vegas",
        image: "/las-vegas.webp",
        price: "£305",
      },
      {
        id: "atlanta",
        name: "Atlanta",
        image: "/atlanta.webp",
        price: "£317",
      },
      {
        id: "dallas",
        name: "Dallas",
        image: "/dallas.avif",
        price: "£317",
      },
      {
        id: "washington",
        name: "Washington",
        image: "/washington.webp",
        price: "£260",
      },
      {
        id: "san-francisco",
        name: "San Francisco",
        image: "/san-f.webp",
        price: "£315",
      },
      {
        id: "tampa",
        name: "Tampa",
        image: "/tampa.webp",
        price: "£317",
      },
    ],
    thingsToDo: [
      "See famous monuments including Liberty Statue and Golden Gate",
      "Tour internationally recognized parks like Yellowstone and Yosemite",
      "Sample varied food offerings from NY pizza to Texas barbecue",
      "Have fun with amusements in cities such as Las Vegas, LA, and Nashville",
      "Find cultural establishments like Smithsonian museums in Washington DC",
    ],
    bestTimeToVisit:
      "The optimal period for visiting America is throughout spring (April to June) and fall (September to November) when climate is agreeable across most zones. These periods provide comfortable conditions for tourism and outside pursuits. Summer works well for coastal locations, while winter suits skiing in mountain areas.",
  },
  {
    id: "canada",
    city: "Canada",
    economy: "£1540",
    premiumEconomy: "£2840",
    image: "/canada.webp",
    description:
      "Canada, the planet's second-biggest nation, is famous for its amazing natural vistas, lively cities, and welcoming society. From the recognizable CN Tower in Toronto to the beautiful appeal of Banff Park, Canada supplies a wide array of encounters. Tourists can investigate the historical roads of Quebec City, appreciate the multicultural attraction of Vancouver, or observe the might of Niagara Falls. The nation's huge wild delivers limitless chances for excitement, including snow sports in Whistler, trekking in the Rockies, and animal viewing in the Arctic.",
    description2:
      "Canada is a land of differences, with busy cities and calm natural marvels. Enjoy the French legacy of Montreal, the contemporary skyline of Calgary, and the cultural wealth of Ottawa. Food enthusiasts can enjoy poutine, butter pastries, and fresh ocean food from the Atlantic shore. The country's friendly residents, deep history, and spectacular scenery make it an essential-visit location. Whether you're looking for urban thrills or wilderness adventure, Canada presents options for everyone.",
    destinations: [
      {
        id: "toronto",
        name: "Toronto",
        image: "/toronto.webp",
        price: "£346",
      },
      {
        id: "vancouver",
        name: "Vancouver",
        image: "/van-couver.webp",
        price: "£415",
      },
      {
        id: "calgary",
        name: "Calgary",
        image: "/calgary.webp",
        price: "£429",
      },
      {
        id: "montreal",
        name: "Montreal",
        image: "/montreal-skyline.webp",
        price: "£375",
      },
    ],
    thingsToDo: [
      "View the grand Niagara Falls and join a boat excursion",
      "Discover the amazing Canadian mountain ranges and nature reserves",
      "Encounter French heritage in Montreal's historic quarters",
      "Participate in whale observation on Atlantic or Pacific shores",
      "Tour top-tier museums and art spaces in Toronto and Ottawa",
    ],
    bestTimeToVisit:
      "The perfect time for visiting Canada relies on your pursuits. For summer pursuits and nice climate, go between June and August. For winter athletics and Aurora displays, December to March is ideal. Autumn (September to October) provides lovely leaves, while spring (April to May) brings blossoming plants and reduced visitors.",
  },
  {
    id: "caribbean",
    city: "Caribbean",
    economy: "£1680",
    premiumEconomy: "£2800",
    image: "/cari.webp",
    description:
      "The Caribbean is a heaven of sun, ocean, and sand, providing perfect beaches, clear waters, and vibrant societies. From the Bahamas to Jamaica, each isle showcases its individual special appeal. Investigate the dense jungles of Dominica, unwind on the pale sandy coasts of Barbados, or plunge into the lively underwater world of the Cayman Isles. The Caribbean is also recognized for its deep history, with colonial-era settlements and energetic festivals honoring its varied legacy.",
    description2:
      "Beyond its amazing coasts, the Caribbean hosts premium resorts, tasty food, and exciting water activities. Snorkel in the coral formations of Belize, move to reggae in Jamaica, or take a picturesque route through the Pitons of St Lucia. Whether you're seeking excitement, relaxation, or cultural discovery, the Caribbean assures a memorable getaway with its warm welcome and amazing landscapes.",
    destinations: [
      {
        id: "montego-bay",
        name: "Montego Bay",
        image: "/montegobay.webp",
        price: "£387",
      },
      {
        id: "kingston",
        name: "Kingston",
        image: "/kingston.webp",
        price: "£390",
      },
      {
        id: "barbados",
        name: "Barbados",
        image: "/barba.webp",
        price: "£410",
      },
      {
        id: "antigua",
        name: "Antigua",
        image: "/Antigua.webp",
        price: "£437",
      },
      {
        id: "grenada",
        name: "Grenada",
        image: "/grenada.webp",
        price: "£538",
      },
    ],
    thingsToDo: [
      "Unwind on internationally famous beaches like Seven Mile and Pink Sands",
      "Snorkel or dive in transparent seas with lively sea creatures",
      "Tour historic colonial villages and UNESCO heritage locations",
      "Enjoy vibrant native culture via music, dancing, and celebrations",
      "Take sailing journeys and island-hopping trips",
    ],
    bestTimeToVisit:
      "The ideal period for visiting the Caribbean is during the arid season from December to April when climate is bright and precipitation is low. This is high visitor period. The intermediate months of May and November provide decent weather with fewer people and improved rates. Storm season lasts from June to November, with maximum danger in August and September.",
  },
  {
    id: "a&n",
    city: "Australia and New Zealand",
    economy: "£1760",
    premiumEconomy: "£2880",
    image: "/aus.webp",
    description:
      "Australia and New Zealand provide amazing scenery, energetic cities, and special wildlife. From the recognizable Sydney Opera House to NZ's fjords and Maori tradition, this zone is a fantasy for explorers and relaxation-chasers alike. Investigate Australia's Outback, scuba dive the Great Barrier Reef, or ski in Queenstown. With premium wines, stunning shorelines, and cosmopolitan centers like Melbourne and Auckland, there's something for all.",
    description2:
      "Beyond the urban areas, find NZ's Middle-earth movie spots, Australia's old jungles, and perfect beaches like the Whitsundays. Whether you're walking Franz Josef Glacier, sampling wine in Marlborough, or viewing kangaroos in nature, Australia and NZ guarantee memorable encounters. Their welcoming residents, outside adventures, and relaxed atmosphere make them perfect for long-distance escapes.",
    destinations: [
      {
        id: "sydney",
        name: "Sydney",
        image: "/sydney.webp",
        price: "£618",
      },
      {
        id: "brisbane",
        name: "Brisbane",
        image: "/brisbane.webp",
        price: "£603",
      },
      {
        id: "melbourne",
        name: "Melbourne",
        image: "/mel.webp",
        price: "£541",
      },
      {
        id: "perth",
        name: "Perth",
        image: "/perth.webp",
        price: "£581",
      },
      {
        id: "auckland",
        name: "Auckland",
        image: "/auck.webp",
        price: "£530",
      },
    ],
    thingsToDo: [
      "Explore the Great Barrier Reef, among the planet's natural marvels",
      "Experience Maori heritage and customs in New Zealand",
      "Find special animals like kangaroos, koalas, and kiwi birds",
      "Tour top-tier vineyards in Australia's Barossa and NZ's Marlborough",
      "Adventure pursuits like bungee leaps, skiing, and trekking",
    ],
    bestTimeToVisit:
      "For Australia, go during their spring (September to November) or autumn (March to May) for agreeable climate. For NZ, summer (December to February) provides warm weather for outside pursuits. The intermediate seasons offer fewer crowds and comfortable temperatures in both nations.",
  },
  {
    id: "africa",
    city: "Africa",
    economy: "£2480",
    premiumEconomy: "£3580",
    image: "/africa.webp",
    description:
      "Africa is a continent of amazing variety, providing everything from huge deserts and green jungles to famous animal tours and vibrant contemporary cities. Home to ancient societies and dramatic scenery, Africa welcomes travelers to experience the Egyptian Pyramids, the Serengeti grasslands of Tanzania, and the gorgeous coastlines of SA. Deep traditions, rhythmic sounds, and warm welcome define the African journey encounter.",
    description2:
      "Beyond safaris and monuments, Africa provides deep cultural involvement and adventure. Observe the Big Five on a game tour, climb Mount Kilimanjaro, investigate the colorful bazaars of Marrakech, or appreciate the picturesque beauty of CT. From luxury camps to economical experiences, Africa serves every tourist seeking authenticity, nature, and memorable recollections.",
    destinations: [
      {
        id: "lagos",
        name: "Lagos",
        image: "/Lagos.webp",
        price: "£317",
      },
      {
        id: "accra",
        name: "Accra",
        image: "/accra.webp",
        price: "£310",
      },
      {
        id: "harare",
        name: "Harare",
        image: "/harare.webp",
        price: "£317",
      },
      {
        id: "cape-town",
        name: "Cape Town",
        image: "/cape.avif",
        price: "£445",
      },
      {
        id: "entebbe",
        name: "Entebbe",
        image: "/Entebbe-town.webp",
        price: "£337",
      },
    ],
    thingsToDo: [
      "Join a wildlife safari to view the Big Five",
      "Investigate ancient historical locations and memorials",
      "Relax on perfect beaches and islands",
      "Experience lively native cultures and festivities",
      "Appreciate picturesque scenery and adventure pursuits",
    ],
    bestTimeToVisit:
      "The ideal period for visiting Africa relies on the zone, but generally May to October works well for safaris due to arid climate and improved animal watching. Coastal and North African places are best visited between October and April when conditions are gentler.",
  },
  {
    id: "latin-america",
    city: "Latin America",
    economy: "£2360",
    premiumEconomy: "£3480",
    image: "/latin.webp",
    description:
      "Latin America is a lively region recognized for its deep culture, dramatic scenery, and energetic traditions. From the old remains of the Incas to the bright streets of colonial towns, Latin America presents a mix of history, music, cuisine, and natural charm. Jungles, mountains, coasts, and cosmopolitan centers make it an exciting location for all kinds of tourists.",
    description2:
      "Move to the beats of salsa and samba, explore the Amazon jungle, or admire famous landmarks like Machu Picchu and Christ Redeemer. Latin America is also renowned for its warm welcome, tasty food, and adventurous character, making it perfect for both relaxation and discovery.",
    destinations: [
      {
        id: "cali",
        name: "Cali",
        image: "/cali.avif",
        price: "£395",
      },
      {
        id: "quito",
        name: "Quito",
        image: "/quito.webp",
        price: "£435",
      },
      {
        id: "lima",
        name: "Lima",
        image: "/lima.webp",
        price: "£390",
      },
      {
        id: "bogota",
        name: "Bogota",
        image: "/bogota.webp",
        price: "£388",
      },
      {
        id: "sao-paulo",
        name: "Sao Paulo",
        image: "/sau.webp",
        price: "£340",
      },
    ],
    thingsToDo: [
      "Investigate ancient ruins and UNESCO heritage locations",
      "Enjoy lively evening life, music, and dancing",
      "Experience varied landscapes from forests to shores",
      "Sample internationally famous Latin dishes",
      "Immerse yourself in native culture and traditions",
    ],
    bestTimeToVisit:
      "The optimal period for visiting Latin America differs by nation, but generally May to October works well for most zones. Coastal regions are excellent year-round, while places like Peru are best visited during the arid season from May to September.",
  },
  {
    id: "asia",
    city: "Asia",
    economy: "£2180",
    premiumEconomy: "£3280",
    image: "/asia.webp",
    description:
      "Asia is the planet's biggest and most varied continent, merging old traditions with contemporary innovation. From the busy roads of Tokyo and Bangkok to the calm shrines of Bali and the Himalayas' grand summits, Asia supplies endless experiences. Deep heritage, spiritual monuments, vibrant food, and dynamic cities make Asia a preferred location for tourists globally.",
    description2:
      "Travelers can investigate ancient temples, enjoy internationally recognized street food, unwind on tropical coasts, or experience futuristic skylines. Asia serves luxury hunters, backpackers, and cultural discoverers alike. Whether it's purchasing in Dubai, meditating in India, or island-jumping in Southeast Asia, the continent guarantees memorable travels.",
    destinations: [
      {
        id: "bangkok",
        name: "Bangkok",
        image: "/bankok.webp",
        price: "£349",
      },
      {
        id: "bali",
        name: "Bali",
        image: "/bali.webp",
        price: "£479",
      },
      {
        id: "phuket",
        name: "Phuket",
        image: "/phuket.avif",
        price: "£365",
      },
      {
        id: "dubai",
        name: "Dubai",
        image: "/dubai.webp",
        price: "£247",
      },
      {
        id: "mumbai",
        name: "Mumbai",
        image: "/mumbai.webp",
        price: "£395",
      },
      {
        id: "delhi",
        name: "Delhi",
        image: "/delhi.webp",
        price: "£395",
      },
      {
        id: "chennai",
        name: "Chennai",
        image: "/chennai.webp",
        price: "£395",
      },
    ],
    thingsToDo: [
      "Investigate ancient temples and historical monuments",
      "Unwind on tropical shores and islands",
      "Sample internationally recognized cuisine and street eats",
      "Purchase in vibrant markets and luxury centers",
      "Enjoy spiritual retreats and cultural festivities",
    ],
    bestTimeToVisit:
      "The ideal period for visiting Asia varies by region, but October to March is generally optimal for Southeast Asia and the Indian subcontinent. East Asia works best in spring (March-May) and autumn (September-November) for agreeable climate.",
  },

  {
    id: "ca",
    city: "Central America",
    economy: "£2320",
    premiumEconomy: "£3360",
    image: "/central.webp",
    description:
      "Central America is a vibrant region bridging North and South America, known for its lush rainforests, volcanic landscapes, and pristine beaches. From the Mayan ruins of Guatemala to the cloud forests of Costa Rica and the Panama Canal, this region offers rich biodiversity and cultural heritage. Explore colonial cities like Antigua, surf in El Salvador, or dive in Belize's Great Blue Hole. Central America's affordability and adventure opportunities make it a favorite for eco-tourists and backpackers.",
    description2:
      "Beyond its natural wonders, Central America boasts vibrant cultures, from the Garifuna communities of Honduras to the indigenous markets of Chichicastenango. Zip-line through Costa Rican jungles, hike active volcanoes in Nicaragua, or relax on Panama's San Blas Islands. With warm hospitality, flavorful cuisine (think pupusas and gallo pinto), and UNESCO World Heritage sites, this compact region packs a punch for travelers seeking authenticity and adventure.",
    destinations: [
      {
        id: "tikal",
        name: "Tikal, Guatemala",
        image: "/tital.webp",
        price: "£1249",
      },
      {
        id: "arenal-volcano",
        name: "Arenal Volcano, Costa Rica",
        image: "/arenal.webp",
        price: "£1299",
      },
      {
        id: "roatan",
        name: "Roatán, Honduras",
        image: "/rotan.webp",
        price: "£1199",
      },
      {
        id: "panama-canal",
        name: "Panama Canal",
        image: "/panama.webp",
        price: "£1349",
      },
      {
        id: "playa-manuel-antonia",
        name: "Playa Manuel Antonia",
        image: "/playa.webp",
        price: "£1249",
      },
      {
        id: "caye-caulker",
        name: "Caye Caulker",
        image: "/caye.webp",
        price: "£1199",
      },
    ],
    thingsToDo: [
      "Explore ancient Mayan ruins and archaeological sites",
      "Go zip-lining through lush rainforest canopies",
      "Surf world-class waves in El Salvador and Nicaragua",
      "Relax on Caribbean beaches and islands",
      "Experience vibrant local markets and traditional crafts",
    ],
    bestTimeToVisit:
      "The dry season from December to April is the best time to visit Central America, with sunny days and minimal rainfall. The shoulder months of May and November can also be good for travel. The rainy season from May to October brings lush green landscapes but more precipitation, particularly in the afternoons.",
  },
  {
    id: "india",
    city: "India",
    economy: "£2235",
    premiumEconomy: "£3256",
    image: "/india.webp",
    description:
      "India, a land of diverse cultures and landscapes, offers something for every traveler. From the majestic Himalayas in the north to the serene backwaters of Kerala in the south, India is a country of contrasts. Explore the iconic Taj Mahal in Agra, a symbol of love and one of the Seven Wonders of the World. The bustling cities of Delhi, Mumbai, and Bangalore showcase India's rapid modernization, while its rural villages offer a glimpse into traditional life.",
    description2:
      "India's rich history is reflected in its countless temples, forts, and palaces, such as the Amber Fort in Jaipur and the temples of Khajuraho. The country's cuisine is equally diverse, with each region offering its own unique flavors and dishes. Don't miss the vibrant festivals, such as Diwali and Holi, which celebrate India's cultural heritage. Whether you're exploring its ancient landmarks or indulging in its culinary delights, India promises an unforgettable journey.",
    destinations: [
      {
        id: "taj-mahal",
        name: "Taj Mahal",
        image: "/tajmahal.webp",
        price: "£1149",
      },
      {
        id: "jaipur",
        name: "Jaipur",
        image: "/jaipur.webp",
        price: "£1049",
      },
      {
        id: "kerala-backwaters",
        name: "Kerala Backwaters",
        image: "/kerala.webp",
        price: "£1199",
      },
      {
        id: "humayun-tomb",
        name: "Humayun's Tomb",
        image: "/humayun.webp",
        price: "£999",
      },
      {
        id: "baga-beach",
        name: "Baga Beach",
        image: "/baga.webp",
        price: "£1099",
      },
      {
        id: "akshardham-temple",
        name: "Akshardham Temple",
        image: "/akshardham.webp",
        price: "£949",
      },
    ],
    thingsToDo: [
      "Visit the Taj Mahal and other UNESCO World Heritage sites",
      "Explore ancient temples, palaces, and forts",
      "Experience traditional Ayurvedic treatments and yoga retreats",
      "Take a houseboat cruise through Kerala's backwaters",
      "Shop for handicrafts, textiles, and spices in local markets",
    ],
    bestTimeToVisit:
      "The best time to visit India is during the cooler months from October to March. North India is pleasant from October to March, while South India is best visited from November to January. The monsoon season (June to September) brings heavy rainfall but lush green landscapes. Summer (April to June) can be very hot in most regions.",
  },
  {
    id: "fareast",
    city: "Far East",
    economy: "£1920",
    premiumEconomy: "£2960",
    image: "/fareast.webp",
    description:
      "The Far East is a mesmerizing blend of ancient traditions and cutting-edge modernity, spanning from Japan's neon-lit cities to Indonesia's tropical paradises. Explore Tokyo's futuristic skyline, Kyoto's serene temples, or the Great Wall of China. Dive into the street food scenes of Bangkok and Taipei, or unwind on Bali's pristine beaches. The region's rich history, diverse cultures, and stunning landscapes make it a bucket-list destination for every traveler.",
    description2:
      "From the bustling markets of Hong Kong to the tranquil rice terraces of Vietnam's Sapa, the Far East offers endless contrasts. Trek through Malaysia's Borneo rainforest, marvel at Angkor Wat's sunrise in Cambodia, or experience Seoul's K-pop culture. Whether you're seeking spiritual retreats in Bhutan, tech wonders in Singapore, or island-hopping in the Philippines, the Far East delivers unforgettable adventures with warm hospitality and unparalleled diversity.",
    destinations: [
      {
        id: "great-wall-china",
        name: "Great Wall of China",
        image: "/greatwall.webp",
        price: "£1349",
      },
      {
        id: "mount-fuji",
        name: "Mount Fuji, Japan",
        image: "/fuji.webp",
        price: "£1449",
      },
      {
        id: "angkor-wat",
        name: "Angkor Wat, Cambodia",
        image: "/angkor.webp",
        price: "£1199",
      },
      {
        id: "halong-bay",
        name: "Halong Bay",
        image: "/holong.avif",
        price: "£1249",
      },
      {
        id: "shibuya",
        name: "Shibuya",
        image: "/shibuya.webp",
        price: "£1499",
      },
      {
        id: "uluwatu-temple",
        name: "Uluwatu Temple",
        image: "/uluvatu.webp",
        price: "£1149",
      },
    ],
    thingsToDo: [
      "Walk along the Great Wall of China and explore the Forbidden City",
      "Experience traditional tea ceremonies and temple visits in Japan",
      "Explore ancient temples like Angkor Wat in Cambodia and Borobudur in Indonesia",
      "Enjoy world-class street food in Bangkok, Singapore, and Hong Kong",
      "Relax on tropical beaches in Thailand, Philippines, and Indonesia",
    ],
    bestTimeToVisit:
      "The best time varies by country in the Far East. Generally, spring (March to May) and autumn (September to November) offer pleasant weather across most regions. Southeast Asia is best visited during the dry season (November to February). Japan is beautiful during cherry blossom season (late March to April) and autumn foliage season (October to November).",
  },
  {
    id: "middleeast",
    city: "Middle East",
    economy: "£1600",
    premiumEconomy: "£2720",
    image: "/middle.webp",
    description:
      "The Middle East is a captivating blend of ancient history and futuristic innovation, from the towering skyscrapers of Dubai to the archaeological wonders of Petra. Explore the bustling souks of Marrakech, the sacred sites of Jerusalem, or the pristine beaches of Oman. The region's rich cultural heritage, warm hospitality, and dramatic landscapes—from deserts to coastlines—make it a must-visit for history buffs, adventurers, and luxury seekers alike.",
    description2:
      "Beyond modern marvels like the Burj Khalifa, discover the timeless beauty of Egypt's Pyramids of Giza, the ruins of Palmyra in Syria, or the spice-scented alleyways of Istanbul. Cruise the Nile, dive in the Red Sea, or trek through Jordan's Wadi Rum. With world-class cuisine (think mezze, kebabs, and Arabic coffee) and vibrant traditions, the Middle East offers a journey through millennia of civilization.",
    destinations: [
      {
        id: "petra",
        name: "Petra, Jordan",
        image: "/petra.webp",
        price: "£1299",
      },
      {
        id: "pyramids-giza",
        name: "Pyramids of Giza, Egypt",
        image: "/pyramids.webp",
        price: "£1199",
      },
      {
        id: "al-ula",
        name: "Al-Ula, Saudi Arabia",
        image: "/alula.webp",
        price: "£1349",
      },
      {
        id: "burj-khalifa",
        name: "Burj Khalifa",
        image: "/burj.webp",
        price: "£1449",
      },
      {
        id: "burj-al-arab",
        name: "Burj Al Arab",
        image: "/burjai.webp",
        price: "£1499",
      },
      {
        id: "dubai-fountain",
        name: "The Dubai Fountain",
        image: "/dfountain.webp",
        price: "£1399",
      },
    ],
    thingsToDo: [
      "Explore ancient archaeological sites and UNESCO World Heritage locations",
      "Experience traditional souks (markets) for spices, textiles, and crafts",
      "Enjoy luxury shopping and modern architecture in Dubai and Abu Dhabi",
      "Take desert safaris and experience Bedouin culture",
      "Visit holy sites in Jerusalem, Mecca, and other religious destinations",
    ],
    bestTimeToVisit:
      "The best time to visit the Middle East is during the cooler months from October to April. Avoid the summer months (June to August) when temperatures can be extremely high. Spring (March to May) and autumn (September to November) offer pleasant weather for sightseeing and outdoor activities.",
  },
  {
    id: "south-america",
    city: "South America",
    economy: "£1899",
    premiumEconomy: "£2899",
    image: "/south.webp",
    description:
      "South America, a continent of breathtaking diversity and vibrant cultures, offers adventures from the Amazon rainforest to the Andes mountains. Discover the ancient ruins of Machu Picchu in Peru, a stunning Inca citadel perched high in the clouds. Brazil's Rio de Janeiro dazzles with its iconic Christ the Redeemer statue and legendary Carnival celebrations, while Argentina's Buenos Aires pulses with tango rhythms and European-style architecture. The continent's natural wonders are unparalleled, from the mighty Iguazu Falls spanning Argentina and Brazil to the otherworldly landscapes of Chile's Atacama Desert.",
    description2:
      "From the colonial charm of Cartagena's colorful streets in Colombia to the wildlife-rich Galapagos Islands of Ecuador, South America promises unforgettable experiences. Explore the wine regions of Mendoza, trek through Patagonia's dramatic glaciers, or cruise along the Amazon River, the world's largest. Each country boasts unique culinary traditions, from Argentina's succulent steaks and Brazil's feijoada to Peru's acclaimed ceviche. Whether you're dancing samba in Salvador, marveling at penguins in Punta Arenas, or exploring the salt flats of Bolivia, South America delivers a journey filled with passion, natural beauty, and cultural richness.",
    destinations: [
      {
        id: "iguazu-falls",
        name: "Iguazu Falls",
        image: "/sm2.webp",
        price: "£1349",
      },
      {
        id: "corcovado",
        name: "Corcovado",
        image: "/sm3.webp",
        price: "£1449",
      },
      {
        id: "sugarloaf-mountain",
        name: "Sugarloaf Mountain",
        image: "/sm4.webp",
        price: "£1399",
      },
      {
        id: "machu-picchu",
        name: "Machu Picchu",
        image: "/machu.webp",
        price: "£1499",
      },
      {
        id: "ipanema-beach",
        name: "Ipanema Beach",
        image: "/ipanema.webp",
        price: "£1299",
      },
      {
        id: "cartagena",
        name: "Walled City of Cartagena",
        image: "/cartagena.webp",
        price: "£1249",
      },
    ],
    thingsToDo: [
      "Hike the Inca Trail to Machu Picchu in Peru",
      "Experience the vibrant Carnival celebrations in Rio de Janeiro",
      "Explore the Amazon rainforest and its incredible biodiversity",
      "Visit the stunning Iguazu Falls on the Argentina-Brazil border",
      "Taste world-class wines in Argentina and Chile's vineyards",
    ],
    bestTimeToVisit:
      "The best time to visit South America varies by region. Generally, the dry seasons offer the best conditions: June to August for Andean countries (Peru, Bolivia), December to March for Patagonia, and April to October for Brazil and the Amazon. The shoulder seasons often provide good weather with fewer tourists.",
  },
  {
    id: "australia",
    city: "Australia",
    economy: "£2499",
    premiumEconomy: "£3499",
    image: "/australia.webp",
    description:
      "Australia, an island continent of staggering contrasts and ancient landscapes, offers adventures from the iconic red deserts of the Outback to the vibrant blue of the Great Barrier Reef. Discover the architectural marvel of the Sydney Opera House against the backdrop of the Harbour Bridge. Western Australia's Perth dazzles with its pristine beaches and sprawling Kings Park, while Victoria's Melbourne pulses with laneway art, world-class coffee, and a legendary sporting culture. The continent's natural wonders are extraordinary, from the prehistoric wilderness of Tasmania's rainforests to the unique wildlife of Kangaroo Island and the geological wonder of Uluru in the heart of the country.",
    description2:
      "From the tropical vibrancy of Cairns and the Daintree Rainforest in Queensland to the coastal cool of Byron Bay's surf culture, Australia promises unforgettable experiences. Explore the wine regions of the Barossa Valley, snorkel among thousands of fish species on the Great Barrier Reef, or road trip along the Great Ocean Road to see the Twelve Apostles. Each region boasts unique culinary delights, from fresh seafood and Sydney rock oysters to high-country wines and modern bush tucker. Whether you're watching the penguin parade on Phillip Island, hiking through the Blue Mountains, or stargazing in the crystal-clear Outback skies, Australia delivers a journey filled with rugged beauty, laid-back charm, and awe-inspiring encounters.",
    destinations: [
      {
        id: "great-barrier-reef",
        name: "Great Barrier Reef",
        image: "/aus1.webp",
        price: "£1799",
      },
      {
        id: "sydney-opera-house",
        name: "Sydney Opera House",
        image: "/aus2.webp",
        price: "£1699",
      },
      {
        id: "uluru",
        name: "Uluru",
        image: "/aus3.webp",
        price: "£1899",
      },
      {
        id: "manly-beach",
        name: "Manly Beach",
        image: "/manly.webp",
        price: "£1599",
      },
      {
        id: "harbour-bridge",
        name: "Harbour Bridge",
        image: "/harbor.webp",
        price: "£1649",
      },
      {
        id: "queen-victoria-market",
        name: "Queen Victoria Market",
        image: "/victoria.webp",
        price: "£1549",
      },
    ],
    thingsToDo: [
      "Snorkel or dive the Great Barrier Reef, the world's largest coral reef system",
      "Explore the iconic Sydney Harbour and climb the Sydney Harbour Bridge",
      "Witness the majestic beauty of Uluru at sunset in the Northern Territory",
      "Take a road trip along Victoria's Great Ocean Road",
      "Encounter unique wildlife like kangaroos, koalas, and quokkas in their natural habitats",
    ],
    bestTimeToVisit:
      "The best time to visit Australia depends on the region. Generally, September to November and March to May (spring and autumn) offer pleasant temperatures nationwide. December to February (summer) is ideal for southern beaches but hot in the centre and wet in the tropical north. June to August (winter) is perfect for the Outback, the Red Centre, and the Great Barrier Reef.",
  },
];

const FlightDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const flight = flights.find((f) => f.id === id);

  if (!flight) {
    return <h2 className="flight-error">Flight not found</h2>;
  }

  const handleCall = () => {
    window.location.href = `tel:02033557350  `;
  };

  const handleClick = () => {
    navigate("/contactus", {
      state: { scrollTo: "fm" },
    });
  };

  // Function to navigate to destination details page
  const handleDestinationClick = (destinationId) => {
    navigate(`/destination/${flight.id}/${destinationId}`);
  };

  return (
    <div className="flight-details-container">
      {/* Hero Section with Blue Overlay */}
      <div className="hero-section">
        <div className="hero-image-container">
          <img src={flight.image} alt={flight.city} className="hero-image" />
          <div className="hero-overlayy">
            <div className="hero-content">
              <h1 className="hero-title">Flights to {flight.city}</h1>
              <p className="hero-subtitle">
                Experience the journey of a lifetime
              </p>
              <div className="hero-actions">
                <button className="hero-button primary" onClick={handleCall}>
                  <span className="button-icon">📞</span>
                  Call Now
                </button>
                <Link className="hgh" to="/contactus">
                  <button className="hero-button secondary">
                    <span className="button-icon">✈️</span>
                    Any Query?
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Deal showHeader={false} />

      {/* Main Content Section */}
      <div className="main-content-section">
        <div className="content-wrapper">
          {/* Left Content */}
          <div className="left-content">
            {/* Destinations Section */}
            <div className="destinations-section tion">
              <div className="section-header">
                <h2 className="section-title">
                  Top Destinations in {flight.city}
                </h2>

                <div className="title-line"></div>
              </div>

              <div className="destinations-container">
                {flight.destinations.map((destination, index) => (
                  <div key={index} className="destination-card">
                    <div className="destination-image-container">
                      <img
                        src={destination.image}
                        alt={destination.name}
                        className="destination-image"
                      />
                      <div className="destination-overlay">
                        <button
                          className="destination-action"
                          onClick={handleCall}
                        >
                          <span className="action-icon">✈️</span>
                          Book Now
                        </button>
                      </div>
                    </div>
                    <div className="destination-content">
                      <h3 className="destination-name">{destination.name}</h3>

                      <div className="btn-abt">
                        <button
                          className="destination-button"
                          onClick={() => handleDestinationClick(destination.id)}
                        >
                          from {destination.price}
                        </button>
                        <button
                          className="destination-button"
                          onClick={handleCall}
                        >
                          Call Now
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="section-header">
              <h2 className="section-title">About {flight.city}</h2>
              <button className="destination-button" onClick={handleCall}>
                Call Now
              </button>
            </div>
            <div className="title-line"></div>

            <div className="description-box">
              <p className="description-text">{flight.description}</p>
            </div>

            {/* Things to Do Section */}
            <div className="things-to-do-section">
              <h3 className="section-title">Things to Do in {flight.city}</h3>
              <div className="title-line"></div>

              <p className="things-description">
                From iconic landmarks to hidden gems, {flight.city} offers a
                wide array of activities for every type of traveler. Whether
                you're seeking adventure, culture, relaxation, or culinary
                delights, you'll find plenty of experiences to make your trip
                memorable.
              </p>

              <div className="things-list">
                {flight.thingsToDo.map((thing, index) => (
                  <div key={index} className="thing-item">
                    <span className="thing-icon">✓</span>
                    <div className="thing-content">
                      <h4>{thing}</h4>
                    </div>
                  </div>
                ))}
              </div>

              {/* Best Time to Visit */}
              <div className="best-time-section">
                <h3 className="section-title">Best Time to Visit</h3>
                <div className="title-line"></div>
                <p className="best-time-description">
                  {flight.bestTimeToVisit}
                </p>
              </div>
            </div>
          </div>

          {/* Right Sidebar */}
          <div className="right-sidebar">
            <div className="contact-card">
              <div className="contact-card-header">
                <img src="/fl.webp" className="contact-img" alt="logo" />
                <h3>
                  Travel Experts <br />
                  <span className="hebr">Get personalized assistance</span>
                </h3>
              </div>

              <div className="contact-info">
                <div className="phone-info" onClick={handleCall}>
                  <span className="phone-icon">📱</span>
                  <div>
                    <p className="phone-label">Call us 24/7</p>
                    <p className="phone-number">02033557350 </p>
                  </div>
                </div>
              </div>
              <p className="contact-description">
                Have any queries?
                <br />
                Fill out the form to request a call back.
              </p>

              <button className="contact-button" onClick={handleClick}>
                Request Call Back
              </button>
            </div>
          </div>
        </div>
      </div>

      <WhyChoose />
    </div>
  );
};

export default FlightDetails;
